var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictureSampleBad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 100,
    viewBox: "0 0 130 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9 66.36C59.4364 74.8199 51.23 75.93 44.12 75.93C28.04 75.93 15 65.2 15 49.12C15 33.04 28.04 20 44.12 20C60.2 20 73.24 33.04 73.24 49.12C73.24 55.98 70.87 61.86 66.9 66.36Z",
    fill: "#583BE2",
    stroke: "#D6CEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6006 80.77L44.1206 76.19L32.6406 80.77V71.09L44.1206 75.67L55.6006 71.09V80.77Z",
    fill: "#D6CEFF",
    stroke: "#D6CEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.19 44.7C36.19 45.51 35.53 46.17 34.72 46.17C33.91 46.17 33.25 45.51 33.25 44.7C33.25 43.89 33.91 43.23 34.72 43.23C35.53 43.23 36.19 43.89 36.19 44.7Z",
    fill: "#D6CEFF",
    stroke: "#D6CEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9791 44.7C54.9791 45.51 54.3191 46.17 53.5091 46.17C52.6991 46.17 52.0391 45.51 52.0391 44.7C52.0391 43.89 52.6991 43.23 53.5091 43.23C54.3191 43.23 54.9791 43.89 54.9791 44.7Z",
    fill: "#D6CEFF",
    stroke: "#D6CEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8594 52.6899C42.3694 51.2099 45.8794 51.2099 49.3894 52.6899",
    stroke: "#D6CEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.477 38.3575L98.6875 44.1475L92.8975 38.3575C91.0875 36.5475 88.1675 36.5475 86.3575 38.3575C84.5475 40.1675 84.5475 43.0875 86.3575 44.8975L92.1475 50.6875L86.3575 56.4775C84.5475 58.2875 84.5475 61.2075 86.3575 63.0175C88.1675 64.8275 91.0875 64.8275 92.8975 63.0175L98.6875 57.2275L104.477 63.0175C106.287 64.8275 109.208 64.8275 111.017 63.0175C112.827 61.2075 112.827 58.2875 111.017 56.4775L105.227 50.6875L111.017 44.8975C112.827 43.0875 112.827 40.1675 111.017 38.3575C109.208 36.5475 106.287 36.5475 104.477 38.3575Z",
    fill: "#D6CEFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureSampleBad);
export default __webpack_public_path__ + "static/media/picture_sample_bad.d4b6fcd4d07dfc3ace6baa6573dc11f0.svg";
export { ForwardRef as ReactComponent };